import { render } from "./HomeStatics.vue?vue&type=template&id=08289e64&scoped=true"
import script from "./HomeStatics.vue?vue&type=script&lang=js"
export * from "./HomeStatics.vue?vue&type=script&lang=js"

import "./HomeStatics.vue?vue&type=style&index=0&id=08289e64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08289e64"]])

export default __exports__